import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { from, Observable } from "rxjs";
import { AppConfigService } from "./Service/Configuration/app-config.service";
import { SessionStorageService } from "./Model/Common/SessionStorageService";
@Injectable({
  providedIn: "root",
})
export class HttpinterceptorInterceptor implements HttpInterceptor {
  
  constructor(
    private appConfig: AppConfigService,
    private sessionStorage: SessionStorageService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenantId = this.sessionStorage.get('tenantId') || '';
    let newBody:any=req.body;
      const modifiedReq = req.clone({
      headers: new HttpHeaders({
        'platform' : 'Web Order',
        'X_Correlation_Id': this.calcCorrelationId(),
        'X-Tenant-ID': tenantId || '',
        // 'X-Tenant-ID': this.appConfig?.setting?.tenantId || '',
        'Access-Control-Allow-Origin':'*'
      }),
      body:newBody
    })
    return next.handle(modifiedReq);
  }
  calcCorrelationId() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
  }
}